import { Button } from "@components/controls/Button"
import { IconInspire } from "@components/svg/Icons"
import { useState } from "react"
import { twMerge } from "tailwind-merge"

export const ActionButton = ({ onClick, title, icon, className }: { onClick: () => void; title: string; icon?: React.ReactNode; className?: string }) => {
  const [hovered, setHovered] = useState(false)

  return (
    <div className={twMerge("pointer-events-auto relative", className)}>
      <p
        className={twMerge(
          "absolute left-1/2 -top-4 -translate-x-1/2 -translate-y-1/2 type-ui-s-roman-caps mb-2 text-center opacity-0 transition-opacity duration-300",
          hovered && "md:opacity-100",
        )}
      >
        {title}
      </p>
      <Button leftIcon={icon || <IconInspire />} onClick={onClick} variant="glass" size="lgSquare" onMouseOver={() => setHovered(true)} onMouseOut={() => setHovered(false)} />
    </div>
  )
}
